import React from "react";
import { Form, Input, Button } from "antd";
import styles from "./ForgotPassword.module.less";
import { useLanguage } from "~/hooks/useLanguage";
import { useSendPasswordResetEmail } from "./hooks/useSendPasswordResetEmail";
import { LoginWrapper } from "../login/LoginWrapper";
import { PAGE_LOGIN } from "~/constants/page";
import { useNavigate } from "react-router-dom";

interface ForgotPasswordProps {}

const ForgotPassword: React.FC<ForgotPasswordProps> = () => {
  const { formatMessage } = useLanguage();
  const { sendPasswordResetEmail, loading } = useSendPasswordResetEmail();

  const navigate = useNavigate();

  const onSubmit = (values: { email: string }) => {
    sendPasswordResetEmail(values.email);
  };

  return (
    <LoginWrapper>
      <Form
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        autoComplete="off"
        className={styles.w100}
      >
        <span className={styles.title}>
          {formatMessage("ForgotPassword.Label.ResetPassword")}
        </span>
        <Form.Item<string>
          name="email"
          rules={[
            {
              required: true,
              message: formatMessage("ForgotPassword.Error.EmailRequired"),
            },
            {
              type: "email",
              message: formatMessage("ForgotPassword.Error.EmailInvalid"),
            },
          ]}
        >
          <Input placeholder={formatMessage("ForgotPassword.Label.Email")} />
        </Form.Item>

        <Form.Item label={null}>
          <Button
            type="default"
            loading={loading}
            className={styles.forgotPasswordButton}
            htmlType="submit"
          >
            {formatMessage("ForgotPassword.Label.ResetPassword").toUpperCase()}
          </Button>
        </Form.Item>
        <div className={styles.backToLoginContainer}>
          <span
            onClick={() => navigate(PAGE_LOGIN)}
            className={styles.backToLogin}
          >
            {formatMessage("ForgotPassword.Label.GoBack")}
          </span>
        </div>
      </Form>
    </LoginWrapper>
  );
};

export default ForgotPassword;
